var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.lists),function(o){return _c('app-order-item',{key:o.order_num,attrs:{"o":o}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }